import React from "react";
import { motion } from "framer-motion";
import { pageMotion } from "../../framer/animation";
import SliderPage from "../../components/SliderPage/SliderPage";
import { SkillSection } from "./styles";
import { FaBrain } from "react-icons/fa";
import { Title, Notes } from "../../styles/reusables";
import SkillList from "./SkillList";

const Skills = () => {
	return (
		<>
			<SliderPage />
			<motion.div
				variants={pageMotion}
				initial='hidden'
				animate='show'
				exit='exit'
			>
				<Title>
					<FaBrain />
					<h2>Skills</h2>
				</Title>
				<SkillSection>
					<div className='skills'>
						<SkillList />
					</div>
					<Notes>
						<h3>Notes</h3>
						<p className='note'>
							Honestly, I don't know how to evaluate my skills since these
							technologies offer so much and they keep developing everyday. One
							day I may think that I'm ready for serious challenges, another day
							I'm upset knowing there's so much to learn.
						</p>
						<p className='note'>
							But it's so exciting to learn something new. Every new technology
							offers an easy and elegant way to solve your problem. CSS styling
							became easier with <span>ScSS</span> or <span>CSS in JS</span>{" "}
							while working with React JS.
						</p>
						<p className='note'>
							And there are many other things like React component libraries
							which allows to write less and clean code. All these things make
							me hungry to learn and finally master something new.
						</p>
					</Notes>
				</SkillSection>
			</motion.div>
		</>
	);
};

export default Skills;
